















































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { Template as TemplateObj } from '@/models'

@Component({
  name: 'Template',
  components: {
    saveTemplateModal: () => import('@/components/modals/saveTemplateModal.vue')
  }
})
export default class Template extends Vue {
  private templates: TemplateObj[] = []

  private fields = [
    { key: 'name', label: `${this.$t('node_template_view.table.name')}` },
    { key: 'description', label: `${this.$t('node_template_view.table.description')}` },
    { key: 'updatedOn', label: `${this.$t('node_template_view.table.date_updated')}` },
    { key: 'action', label: `${this.$t('table.actions')}` }
  ]

  private templateEdit: TemplateObj = { templateId: 0, name: '', description: '', structure: {} }

  created() {
    this.loadTemplates()
  }

  private async loadTemplates() {
    const response = await ApiClient.getTemplates()
    this.templates = response
  }

  private editTemplate(template: TemplateObj) {
    this.templateEdit = Object.assign({}, this.templateEdit, template)
    this.$bvModal.show('saveTemplateModal')
  }

  private newTemplate() {
    this.templateEdit = Object.assign({}, this.templateEdit, { templateId: 0, name: '', description: '', structure: {} })
    this.$bvModal.show('saveTemplateModal')
  }
}
